import UpdatePhoneOnZip from '@sparta.global.utilities/update-phone-based-on-zip-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { secureLink } from '@sparta.global.helpers/secure-link-helper/dist/es6.js';
import { svgHelper } from '@sparta.global.helpers/svg-helper/dist/es6.js';
import { cardHelper } from '@sparta.global.helpers/card-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"skin-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1), depth0))
    + "\">";
},"3":function(container,depth0,helpers,partials,data) {
    return " extend-bottom-margin";
},"5":function(container,depth0,helpers,partials,data) {
    return "          block-medium-split=\"true\"\r\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"block-container "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"displayClass") || (depth0 != null ? lookupProperty(depth0,"displayClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"displayClass","hash":{},"data":data,"loc":{"start":{"line":16,"column":38},"end":{"line":16,"column":54}}}) : helper)))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"smallCentered")),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":55},"end":{"line":16,"column":110}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"renderCardWrapper")||(depth0 && lookupProperty(depth0,"renderCardWrapper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"renderCardWrapper","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":60,"column":34}}})) != null ? stack1 : "")
    + "          </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "small-centered";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div\r\n                class=\"block-inner"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"smallCentered")),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":34},"end":{"line":19,"column":90}}})) != null ? stack1 : "")
    + "\"\r\n                id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"buttonID") || (depth0 != null ? lookupProperty(depth0,"buttonID") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"buttonID","hash":{},"data":data,"loc":{"start":{"line":20,"column":20},"end":{"line":20,"column":32}}}) : helper)))
    + "\"\r\n              >\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":16},"end":{"line":26,"column":23}}})) != null ? stack1 : "")
    + "\r\n                <div class=\"content-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":18},"end":{"line":37,"column":25}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":18},"end":{"line":47,"column":25}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"chat") : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":18},"end":{"line":57,"column":25}}})) != null ? stack1 : "")
    + "                </div>\r\n              </div>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    return " small-centered";
},"13":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <div class=\"icon\">\r\n                    "
    + container.escapeExpression((lookupProperty(helpers,"renderIconMarkup")||(depth0 && lookupProperty(depth0,"renderIconMarkup"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"renderIconMarkup","hash":{},"data":data,"loc":{"start":{"line":24,"column":20},"end":{"line":24,"column":45}}}))
    + "\r\n                  </div>\r\n";
},"15":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"title\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),"==","appointmentLink",{"name":"compare","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.program(18, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":31,"column":22},"end":{"line":35,"column":34}}})) != null ? stack1 : "")
    + "                    </div>\r\n";
},"16":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        "
    + container.escapeExpression((lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"copy") : depths[1])) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"appointmentLink") : stack1),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":32,"column":24},"end":{"line":32,"column":90}}}))
    + "\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":34,"column":24},"end":{"line":34,"column":35}}}) : helper))) != null ? stack1 : "")
    + "\r\n";
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"content "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"contentClass") || (depth0 != null ? lookupProperty(depth0,"contentClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contentClass","hash":{},"data":data,"loc":{"start":{"line":40,"column":40},"end":{"line":40,"column":56}}}) : helper)))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"each","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":22},"end":{"line":45,"column":31}}})) != null ? stack1 : "")
    + "                    </div>\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <p class=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":42,"column":34},"end":{"line":42,"column":43}}}) : helper)))
    + "\">\r\n                          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":43,"column":26},"end":{"line":43,"column":36}}}) : helper))) != null ? stack1 : "")
    + "\r\n                        </p>\r\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"chat-container show-for-medium-up\" id=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"chat") : depth0)) != null ? lookupProperty(stack1,"mediumUp") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n                    </div>\r\n\r\n                    <div class=\"chat-container show-for-small-only\" id=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"chat") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n                    </div>\r\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"showSocial") : stack1),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":10},"end":{"line":73,"column":17}}})) != null ? stack1 : "");
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"socialModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"28":function(container,depth0,helpers,partials,data) {
    return "</div>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":60}}})) != null ? stack1 : "")
    + "\r\n  <div\r\n    class=\"row large-collapse"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"extendBottomMargin") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":29},"end":{"line":3,"column":90}}})) != null ? stack1 : "")
    + "\"\r\n    id=\"connect-container\"\r\n  >\r\n    <div class=\"column large-10 large-offset-1 end\">\r\n      <h2 id=\"heading\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"headingClass") : stack1), depth0))
    + "\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n\r\n      <div\r\n        class=\"blocks-container\"\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"blocks") : stack1)) != null ? lookupProperty(stack1,"length") : stack1),">=","4",{"name":"compare","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":8},"end":{"line":13,"column":20}}})) != null ? stack1 : "")
    + "      >\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"blocks") : stack1),{"name":"each","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":8},"end":{"line":62,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"column\">\r\n      <div class=\"social-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"socialModule") : stack1),{"name":"if","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":70,"column":8},"end":{"line":74,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1),{"name":"if","hash":{},"fn":container.program(28, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":78,"column":0},"end":{"line":78,"column":32}}})) != null ? stack1 : "")
    + "\r\n";
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

/**
 * Include the block content as part of helper
 * @param {Object} config JCR JSON
 * @param {Object} context Content for the connect card
 * @returns 
 */
function setBlockContent(config, context) {
  if (context && context.isBlockHelperOptions) {
    const blockHelperTemplate = Handlebars.compile(`${context.helperBlockContent}`);
    return blockHelperTemplate(config);
  }
  if (context && Object.prototype.hasOwnProperty.call(context, 'fn')) {
    return context.fn(config);
  }
}

/**
 * Creates the HTML output for the component item
 * @param {String} iconValue File path or icon name that will be used to generate the icon output
 * @returns 
 */
function renderIconMarkup(iconValue) {
  // We've been given the BAU URL
  if (iconValue.includes('spa-assets/images')) {
    return new Handlebars.SafeString(`<img height="100%" width="100%" src="${iconValue}" aria-hidden="true" role="img"/>`);
  }

  // Else we have an icon name and need to use SVG helper
  const loadingIcon = svgHelper({
    type: 'static',
    iconName: iconValue,
    ariaHidden: 'true',
    height: '24px',
    width: '24px'
  });
  return new Handlebars.SafeString(loadingIcon);
}

/**
* Builds a wrapper around the module content
* @param {Object} config JCR fed into the module
* @param {Object} context Block helper content
*/
function renderCardWrapper(config, context) {
  const output = cardHelper({}, {
    dismissible: false,
    disableDismissibleADA: true,
    class: "block",
    markup: {
      content: setBlockContent(config, context)
    }
  }) || '';
  return new Handlebars.SafeString(output);
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/connect-with-us-module",
  "version": "1.1.9",
  "id": "connectWithUsModule",
  "containerID": "globalConnectWithUsModule",
  "moduleName": "global-connect-with-us-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "connect-with-us-module",
  "data": {
    "init": "ConnectWithUsModule"
  },
  "moduleParams": [{
    "name": "skin",
    "type": "string",
    "values": ["warm", "cool", "cool-inverted", "none"],
    "default": "none",
    "description": "New skin, warm is from the older color palette, cool is the new 2017 colors."
  }, {
    "name": "extendBottomMargin",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Adds extended margin to the bottom of the module."
  }, {
    "name": "smallCentered",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Centers the box content in small view."
  }, {
    "name": "checkPilotZip",
    "type": "boolean",
    "default": false,
    "description": "Check to see if we should be changing the phone number for whatever reason."
  }, {
    "name": "showSocial",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Displays social section when true or unspecified."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        json,
        secureLink,
        svgHelper,
        renderIconMarkup,
        renderCardWrapper
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    json,
    secureLink,
    svgHelper,
    renderIconMarkup,
    renderCardWrapper
  },
  "dependencies": {
    "@sparta.global.helpers/card-helper": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.3",
    "@sparta.global.helpers/json-helper": "^1.0.2",
    "@sparta.global.helpers/secure-link-helper": "^1.0.2",
    "@sparta.global.helpers/svg-helper": "^2.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.1.8",
    "@sparta.global.utilities/sparta-color-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-spacing-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-global-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-breakpoint-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/update-phone-based-on-zip-utility": "^1.0.3",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.5.1"
  },
  "stores": []
};

/**
 * Class to create a Connect With Us component.
 */
class ConnectWithUsModule extends Module {
  /**
   * Initialize module.
   * @returns {void}
   */
  init() {
    // Init the ZIP code check to update phone number.
    if (this.params.checkPilotZip) {
      UpdatePhoneOnZip.checkPageAgainstPilot();
    }

    // Allow accordion behavior.
    this.settings.$target.find('.accordion-trigger').click(function handleAccordionClick(e) {
      const $accordionContainer = $(this).closest('.content-container').find('.content').first();
      $accordionContainer.slideToggle();
      this.classList.toggle('expanded');
      e.stopPropagation();
    });

    // Prevent bubbling up before transferring link to clickable block.
    $('.title-link').on('click', event => {
      event.stopPropagation();
    });

    // Transfer link to clickable block.
    $('.block-container.clickable').on('click', function handleBlockClick() {
      const titleLink = $(this).find('.title-link')[0];
      if (titleLink.classList.contains('accordion-trigger')) {
        titleLink.click();
      } else {
        const {
          href,
          target
        } = titleLink;
        if (href) {
          if (target) {
            window.open(href, target);
          } else {
            window.open(href, '_self');
          }
        }
      }
    });
  }
}
registerModuleClass({
  moduleClass: ConnectWithUsModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ConnectWithUsModule as default, moduleConfig };
